<template>
  <div v-click-outside="hide" class="component-period-select form-group">
    <responsive-select
      :id="id"
      icon="icon-calendar"
      :slim="slim"
      :ultraSlim="ultraSlim"
      :label="label"
      v-model="innerValue"
      :class="classObject"
      :disabled="disabled"
      :placeholder="placeholder"
      :options="options"
    />
    <div class="d-none d-lg-block">
      <date-picker
        v-model="dates"
        :visible="pickerVisible"
        @hide="hide"
        @submit="submit"
      />
    </div>
    <responsive-modal v-if="isMobile" v-model="pickerVisible">
      <date-picker
        v-model="dates"
        :visible="true"
        @hide="hide"
        @submit="submit"
        positionRelative
      />
    </responsive-modal>
  </div>
</template>
<script>
import ResponsiveSelect from "@/components/ResponsiveSelect";
import vClickOutside from "v-click-outside";
import moment from "moment";

export default {
  components: {
    ResponsiveSelect
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    options: {
      type: Array,
      default: () => [
        { id: 1, name: "1 dia" },
        { id: 7, name: "7 dias" },
        { id: 15, name: "15 dias" },
        { id: 30, name: "30 dias" },
        { id: 45, name: "45 dias" },
        { id: 90, name: "3 meses" },
        { id: 180, name: "6 meses" },
        { id: 365, name: "12 meses" },
        { id: 540, name: "18 meses" },
        { id: 730, name: "24 meses" },
        { id: null, name: "Selecionar período" }
      ]
    },
    id: {
      type: [String, Number],
      default: "id"
    },
    label: {
      type: String,
      default: ""
    },
    classObject: {
      type: [Object, String],
      default: () => {}
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ""
    },
    slim: {
      type: Boolean,
      default: false
    },
    ultraSlim: {
      type: Boolean,
      default: false
    },
    radius: {
      type: Boolean,
      default: false
    },
    value: {
      //Value expect this: ['2021-05-10', '2021-05-17] [0] -> start_day -- [1] -> end_day
      type: Array,
      default: () => []
    }
  },
  watch: {
    innerValue(val) {
      this.changeDateType(val);
    },
    dates(v) {
      if (v && v.length === 2) {
        this.$store.commit("sale/setFilterDates", v);
      }
      this.$emit("input", v);
    }
  },
  computed: {
    isMobile() {
      return window.innerWidth < 991;
    }
  },
  data() {
    return {
      pickerVisible: false,
      innerValue: "",
      dates: undefined
    };
  },
  methods: {
    hide() {
      this.pickerVisible = false;
    },
    changeDateType(daysCount) {
      if (daysCount === null) {
        this.dates = undefined;
        this.pickerVisible = true;
      } else {
        this.dates = [
          moment()
            .subtract(daysCount - 1, "days")
            .format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD")
        ];
      }
    },
    submit() {
      this.$emit("input", this.dates);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.component-period-select {
  position: relative;
  .slim-size {
    min-height: 32px !important;
  }
  .overview-card {
    background: white !important;
  }
}
</style>
